import { readItems, deleteItems, updateItems } from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";
const directus = getDirectusClient();
export const getserialesCount = async (id) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["id"],
        filter: {
          _and: [
            {
              producto_odc: {
                id: {
                  _eq: id,
                },
              },
            },
          ],
        },
        aggregate: {
          countDistinct: ["id"],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const traerserialesPorFacturaCount = async (facturaId) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["id", "serial"],
        filter: {
          _and: [
            {
              estado: {
                id: {
                  _eq: 2,
                },
              },
            },
            {
              produtofactura: { factura: { id: { _eq: facturaId } } },
            },
          ],
        },
        aggregate: {
          countDistinct: ["id"],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const traerserialesPorFactura = async (facturaId) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["id", "serial"],
        filter: {
          _and: [
            {
              estado: {
                id: {
                  _eq: 2,
                },
              },
            },
            {
              produtofactura: { factura: { id: { _eq: facturaId } } },
            },
          ],
        },
        limit: -1,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getseriales = async (page = 1, limit = 20) => {
  try {
    const response = await directus.request(
      readItems("seriales", { fields: ["*.*"], limit: limit, page: page })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getserialesByserial = async (serial, page = 1, limit = -1) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["*.*", "producto.grupo.*"],
        filter: { serial: { _contains: serial } },
        page: page,
        limit: limit,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getserialeslistcount = async (userRoleID, userBodega) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["*.*"],

        filter: {
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
                bodega: {
                  id: { _eq: userBodega },
                },
              }
            : {}),
        },

        aggregate: {
          countDistinct: ["id"],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getSerialesList = async (
  page = 1,
  limit = 20,
  search = "",
  searchType = "all",
  userRoleID,
  userBodega,
  dateFilter = {}
) => {
  try {
    let filter = {
      ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
        ? {
            bodega: {
              id: { _eq: userBodega },
            },
          }
        : {}),
    };

    if (searchType === "product" && search) {
      filter = {
        ...filter,
        _and: [
          {
            producto: {
              nombre: {
                _contains: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "orden" && search) {
      filter = {
        ...filter,
        _and: [
          {
            orden_compra_ingreso: {
              id: {
                _eq: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "estado" && search) {
      filter = {
        ...filter,
        _and: [
          {
            estado: {
              estado: {
                _contains: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "group" && search) {
      filter = {
        ...filter,
        _and: [
          {
            producto: {
              grupo: {
                nombre: {
                  _contains: search,
                },
              },
            },
          },
        ],
      };
    }
    if (searchType === "serial" && search) {
      filter = {
        ...filter,
        _and: [
          {
            serial: {
              _contains: search,
            },
          },
        ],
      };
    }
    if (searchType === "both" && search) {
      const [
        productSearch,
        groupSearch,
        ordenSearch,
        estadoSearch,
        bodegaSearch,

        vendedorRutaSearch,

        vendedorTropasSearch,
      ] = search.split("|").map((s) => s.trim());
      const conditions = [];

      if (
        productSearch &&
        productSearch !== "undefined" &&
        productSearch !== ""
      ) {
        conditions.push({
          producto: {
            nombre: {
              _in: productSearch.split(","),
            },
          },
        });
      }

      if (groupSearch && groupSearch !== "undefined" && groupSearch !== "") {
        conditions.push({
          producto: {
            grupo: {
              nombre: {
                _in: groupSearch.split(","),
              },
            },
          },
        });
      }
      if (ordenSearch && ordenSearch !== "undefined" && ordenSearch !== "") {
        conditions.push({
          orden_compra_ingreso: {
            id: {
              _eq: ordenSearch,
            },
          },
        });
      }
      if (estadoSearch && estadoSearch !== "undefined" && estadoSearch !== "") {
        conditions.push({
          estado: {
            estado: {
              _eq: estadoSearch,
            },
          },
        });
      }
      if (bodegaSearch && bodegaSearch !== "undefined" && bodegaSearch !== "") {
        conditions.push({
          bodega: {
            id: {
              _eq: bodegaSearch,
            },
          },
        });
      }

      if (
        vendedorRutaSearch &&
        vendedorRutaSearch !== "undefined" &&
        vendedorRutaSearch !== ""
      ) {
        conditions.push({
          user: {
            id: {
              _eq: vendedorRutaSearch,
            },
          },
        });
      }

      if (
        vendedorTropasSearch &&
        vendedorTropasSearch !== "undefined" &&
        vendedorTropasSearch !== ""
      ) {
        conditions.push({
          user: {
            id: {
              _eq: vendedorTropasSearch,
            },
          },
        });
      }

      if (conditions.length > 0) {
        filter = {
          ...filter,
          _and: conditions,
        };
      }
    }

    // Agregar filtros de fecha si existen
    if (Object.keys(dateFilter).length > 0) {
      if (filter._and) {
        filter._and.push(dateFilter);
      } else {
        filter = {
          ...filter,
          _and: [dateFilter],
        };
      }
    }

    const response = await directus.request(
      readItems("seriales", {
        fields: [
          "id",
          "serial",
          "min",
          "iccid",
          "estado.estado",
          "bodega.nombre",
          "producto.id",
          "prestamo.prestamos_id.vendedor.first_name",
          "producto.nombre",
          "producto.preciosinimp",
          "producto.grupo.impuesto",
          "producto.grupo.nombre",
          "orden_compra_ingreso.id",
          "orden_compra_ingreso.numero_factura",
          "orden_compra_ingreso.date_created",
          "orden_compra_ingreso.date_updated",
          "orden_compra_ingreso.user_created.first_name",
          "orden_compra_ingreso.ingresado_por.first_name",
          "orden_compra_ingreso.estado.nombre",
          "orden_compra_ingreso.proveedor.nombre",
          "orden_compra_ingreso.user_created.first_name",
          "orden_compra_ingreso.productos.producto_detalle.id",
          "orden_compra_ingreso.productos.precio_uni_final",
          "date_created",
          "user.first_name",
          "user.role.name",
          "user.documento",
          "user.celular",
          "user.correo_electronico",
          "user.superior.first_name",
          "user.superior.role.name",
          "user.superior.superior.first_name",
          "user.superior.superior.role.name",
          "user.superior.superior.superior.first_name",
          "user.superior.superior.superior.role.name",
        ],
        filter,
        limit,
        page,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getSerialesCount = async (userRoleID, userBodega) => {
  try {
    const filter = {
      ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
        ? {
            bodega: {
              id: { _eq: userBodega },
            },
          }
        : {}),
    };

    const response = await directus.request(
      readItems("seriales", {
        fields: ["*.*"],
        filter,
        aggregate: {
          countDistinct: ["id"],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSerialesListSimple = async (
  page = 1,
  limit = 20,
  search = "",
  searchType = "all",
  userRoleID,
  userBodega,
  dateFilter = {}
) => {
  try {
    let filter = {
      ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
        ? {
            bodega: {
              id: { _eq: userBodega },
            },
          }
        : {}),
    };

    if (searchType === "product" && search) {
      filter = {
        ...filter,
        _and: [
          {
            producto: {
              id: {
                _eq: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "orden" && search) {
      filter = {
        ...filter,
        _and: [
          {
            orden_compra_ingreso: {
              id: {
                _eq: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "estado" && search) {
      filter = {
        ...filter,
        _and: [
          {
            estado: {
              id: {
                _eq: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "group" && search) {
      filter = {
        ...filter,
        _and: [
          {
            producto: {
              grupo: {
                id: {
                  _eq: search,
                },
              },
            },
          },
        ],
      };
    }
    if (searchType === "serial" && search) {
      filter = {
        ...filter,
        _and: [
          {
            serial: {
              _contains: search,
            },
          },
        ],
      };
    }
    if (searchType === "both" && search) {
      const [
        productSearch,
        groupSearch,
        ordenSearch,
        estadoSearch,
        bodegaSearch,

        vendedorRutaSearch,

        vendedorTropasSearch,
      ] = search.split("|").map((s) => s.trim());
      const conditions = [];

      if (
        productSearch &&
        productSearch !== "undefined" &&
        productSearch !== ""
      ) {
        conditions.push({
          producto: {
            id: {
              _in: productSearch.split(","),
            },
          },
        });
      }

      if (groupSearch && groupSearch !== "undefined" && groupSearch !== "") {
        conditions.push({
          producto: {
            grupo: {
              id: {
                _in: groupSearch.split(","),
              },
            },
          },
        });
      }
      if (ordenSearch && ordenSearch !== "undefined" && ordenSearch !== "") {
        conditions.push({
          orden_compra_ingreso: {
            id: {
              _eq: ordenSearch,
            },
          },
        });
      }
      if (estadoSearch && estadoSearch !== "undefined" && estadoSearch !== "") {
        conditions.push({
          estado: {
            id: {
              _eq: estadoSearch,
            },
          },
        });
      }
      if (bodegaSearch && bodegaSearch !== "undefined" && bodegaSearch !== "") {
        conditions.push({
          bodega: {
            id: {
              _eq: bodegaSearch,
            },
          },
        });
      }

      if (
        vendedorRutaSearch &&
        vendedorRutaSearch !== "undefined" &&
        vendedorRutaSearch !== ""
      ) {
        conditions.push({
          user: {
            id: {
              _eq: vendedorRutaSearch,
            },
          },
        });
      }

      if (
        vendedorTropasSearch &&
        vendedorTropasSearch !== "undefined" &&
        vendedorTropasSearch !== ""
      ) {
        conditions.push({
          user: {
            id: {
              _eq: vendedorTropasSearch,
            },
          },
        });
      }

      if (conditions.length > 0) {
        filter = {
          ...filter,
          _and: conditions,
        };
      }
    }

    // Agregar filtros de fecha si existen
    if (Object.keys(dateFilter).length > 0) {
      if (filter._and) {
        filter._and.push(dateFilter);
      } else {
        filter = {
          ...filter,
          _and: [dateFilter],
        };
      }
    }

    const response = await directus.request(
      readItems("seriales", {
        fields: [
          "id",
          "serial",
          "min",
          "iccid",
          "estado.estado",
          "bodega.nombre",
        ],
        filter,
        limit,
        page,
        sort: ["-id"],
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSerialesFilteredCount = async (
  search = "",
  searchType = "all",
  userRoleID,
  userBodega,
  dateFilter = {}
) => {
  try {
    let filter = {
      ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
        ? {
            bodega: {
              id: { _eq: userBodega },
            },
          }
        : {}),
    };

    if (searchType === "product" && search) {
      filter = {
        ...filter,
        _and: [
          {
            producto: {
              id: {
                _eq: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "group" && search) {
      filter = {
        ...filter,
        _and: [
          {
            producto: {
              grupo: {
                id: {
                  _eq: search,
                },
              },
            },
          },
        ],
      };
    }
    if (searchType === "orden" && search) {
      filter = {
        ...filter,
        _and: [
          {
            orden_compra_ingreso: {
              id: {
                _eq: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "estado" && search) {
      filter = {
        ...filter,
        _and: [
          {
            estado: {
              id: {
                _eq: search,
              },
            },
          },
        ],
      };
    }
    if (searchType === "serial" && search) {
      filter = {
        ...filter,
        _and: [
          {
            serial: {
              _contains: search,
            },
          },
        ],
      };
    }
    if (searchType === "both" && search) {
      const [
        productSearch,
        groupSearch,
        ordenSearch,
        estadoSearch,
        bodegaSearch,

        vendedorRutaSearch,

        vendedorTropasSearch,
      ] = search.split("|").map((s) => s.trim());
      const conditions = [];

      if (
        productSearch &&
        productSearch !== "undefined" &&
        productSearch !== ""
      ) {
        conditions.push({
          producto: {
            id: {
              _in: productSearch.split(","),
            },
          },
        });
      }

      if (groupSearch && groupSearch !== "undefined" && groupSearch !== "") {
        conditions.push({
          producto: {
            grupo: {
              id: {
                _in: groupSearch.split(","),
              },
            },
          },
        });
      }
      if (ordenSearch && ordenSearch !== "undefined" && ordenSearch !== "") {
        conditions.push({
          orden_compra_ingreso: {
            id: {
              _eq: ordenSearch,
            },
          },
        });
      }
      if (estadoSearch && estadoSearch !== "undefined" && estadoSearch !== "") {
        conditions.push({
          estado: {
            id: {
              _eq: estadoSearch,
            },
          },
        });
      }
      if (bodegaSearch && bodegaSearch !== "undefined" && bodegaSearch !== "") {
        conditions.push({
          bodega: {
            id: {
              _eq: bodegaSearch,
            },
          },
        });
      }

      if (
        vendedorRutaSearch &&
        vendedorRutaSearch !== "undefined" &&
        vendedorRutaSearch !== ""
      ) {
        conditions.push({
          user: {
            id: {
              _eq: vendedorRutaSearch,
            },
          },
        });
      }

      if (
        vendedorTropasSearch &&
        vendedorTropasSearch !== "undefined" &&
        vendedorTropasSearch !== ""
      ) {
        conditions.push({
          user: {
            id: {
              _eq: vendedorTropasSearch,
            },
          },
        });
      }

      if (conditions.length > 0) {
        filter = {
          ...filter,
          _and: conditions,
        };
      }
    }

    // Agregar filtros de fecha si existen
    if (Object.keys(dateFilter).length > 0) {
      if (filter._and) {
        filter._and.push(dateFilter);
      } else {
        filter = {
          ...filter,
          _and: [dateFilter],
        };
      }
    }

    const response = await directus.request(
      readItems("seriales", {
        fields: ["*.*"],
        filter,
        aggregate: {
          countDistinct: ["id"],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteSerialesByOrder = async (orderId, productId) => {
  try {
    const directus = await getDirectusClient();

    const seriales = await directus.request(
      readItems("seriales", {
        fields: ["id", "serial", "estado"],
        filter: {
          _and: [
            { orden_compra_ingreso: { _eq: orderId } },
            { producto_odc: { _eq: productId } },
          ],
        },
        limit: -1,
      })
    );

    if (seriales && seriales.length > 0) {
      await directus.request(
        deleteItems("seriales", {
          filter: {
            _and: [
              { orden_compra_ingreso: { _eq: orderId } },
              { producto_odc: { _eq: productId } },
            ],
          },
          limit: -1, // Agregar límite para eliminar todos los registros
        })
      );

      return { success: true, serialesEliminados: seriales.length };
    }

    return {
      success: false,
      message: "No se encontraron seriales para eliminar",
    };
  } catch (error) {
    throw error;
  }
};

export const GetSerialesByOrder = async (orderId, productId) => {
  try {
    const directus = await getDirectusClient();

    const seriales = await directus.request(
      readItems("seriales", {
        fields: ["id", "serial", "estado.estado"],
        filter: {
          _and: [
            { orden_compra_ingreso: { _eq: orderId } },
            { producto_odc: { _eq: productId } },
          ],
        },
        limit: -1,
      })
    );

    return seriales || [];
  } catch (error) {
    throw error;
  }
};

export const getCajasByProducto = async (productoId) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["caja"],
        filter: {
          produtofactura: {
            id: {
              _eq: productoId,
            },
          },
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPrimerSerialByCaja = async (caja) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["id", "serial", "caja"],
        filter: {
          caja: {
            _eq: caja,
          },
        },
        sort: ["id"],
        limit: 1,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getUltimoSerialByCaja = async (caja) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["id", "serial", "caja"],
        filter: {
          caja: {
            _eq: caja,
          },
        },
        sort: ["-id"],
        limit: 1,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTotalSerialesByCaja = async (caja) => {
  try {
    const response = await directus.request(
      readItems("seriales", {
        fields: ["id"],
        filter: {
          caja: {
            _eq: caja,
          },
        },
        aggregate: {
          countDistinct: ["id"],
        },
        limit: -1,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createReportSerials = async (params) => {
  const {
    timezone_offset = 0,
    fecha_facturacion_start = null,
    fecha_facturacion_end = null,
    fecha_creacion_start = null,
    fecha_creacion_end = null,
    fecha_order_de_compra_start = null,
    fecha_order_de_compra_end = null,
    vendedor_id = null,
    bodega_id = null,
    grupo_id = null,
    producto_id = null,
    estado_serial_id = null,
  } = params;

  const queryParams = new URLSearchParams();

  if (timezone_offset !== null)
    queryParams.append("timezone_offset", timezone_offset);
  if (fecha_facturacion_start)
    queryParams.append("fecha_facturacion_start", fecha_facturacion_start);
  if (fecha_facturacion_end)
    queryParams.append("fecha_facturacion_end", fecha_facturacion_end);
  if (fecha_creacion_start)
    queryParams.append("fecha_creacion_start", fecha_creacion_start);
  if (fecha_creacion_end)
    queryParams.append("fecha_creacion_end", fecha_creacion_end);
  if (fecha_order_de_compra_start)
    queryParams.append(
      "fecha_order_de_compra_start",
      fecha_order_de_compra_start
    );
  if (fecha_order_de_compra_end)
    queryParams.append("fecha_order_de_compra_end", fecha_order_de_compra_end);
  if (vendedor_id) queryParams.append("vendedor_id", vendedor_id);
  if (bodega_id) queryParams.append("bodega_id", bodega_id);

  // Manejar arrays para grupo_id y producto_id
  if (grupo_id && Array.isArray(grupo_id) && grupo_id.length > 0) {
    grupo_id.forEach((id) => queryParams.append("grupo_id", id));
  } else if (grupo_id) {
    queryParams.append("grupo_id", grupo_id);
  }

  if (producto_id && Array.isArray(producto_id) && producto_id.length > 0) {
    producto_id.forEach((id) => queryParams.append("producto_id", id));
  } else if (producto_id) {
    queryParams.append("producto_id", producto_id);
  }

  if (estado_serial_id)
    queryParams.append("estado_serial_id", estado_serial_id);

  const response = await fetch(
    `${
      process.env.REACT_APP_URL_SERIAL
    }/reports/generate?${queryParams.toString()}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    }
  );

  return response;
};
export const getReportsSerials = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_URL_SERIAL}/reports/files`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const estadoSeriales = async () => {
  try {
    const response = await directus.request(
      readItems("estado_seriales", {
        fields: ["id", "estado"],
      })
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSeriales = async (params) => {
  const {
    timezone_offset = 0,
    fecha_facturacion_start = null,
    fecha_facturacion_end = null,
    fecha_creacion_start = null,
    fecha_creacion_end = null,
    fecha_order_de_compra_start = null,
    fecha_order_de_compra_end = null,
    vendedor_id = null,
    bodega_id = null,
    grupo_id = null,
    producto_id = null,
    estado_serial_id = null,
    serial = null,
  } = params;

  const queryParams = new URLSearchParams();

  if (timezone_offset !== null)
    queryParams.append("timezone_offset", timezone_offset);
  if (fecha_facturacion_start)
    queryParams.append("fecha_facturacion_start", fecha_facturacion_start);
  if (fecha_facturacion_end)
    queryParams.append("fecha_facturacion_end", fecha_facturacion_end);
  if (fecha_creacion_start)
    queryParams.append("fecha_creacion_start", fecha_creacion_start);
  if (fecha_creacion_end)
    queryParams.append("fecha_creacion_end", fecha_creacion_end);
  if (fecha_order_de_compra_start)
    queryParams.append(
      "fecha_order_de_compra_start",
      fecha_order_de_compra_start
    );
  if (fecha_order_de_compra_end)
    queryParams.append("fecha_order_de_compra_end", fecha_order_de_compra_end);
  if (vendedor_id) queryParams.append("vendedor_id", vendedor_id);
  if (bodega_id) queryParams.append("bodega_id", bodega_id);

  // Manejar arrays para grupo_id y producto_id
  if (grupo_id && Array.isArray(grupo_id) && grupo_id.length > 0) {
    grupo_id.forEach((id) => queryParams.append("grupo_id", id));
  } else if (grupo_id) {
    queryParams.append("grupo_id", grupo_id);
  }

  if (producto_id && Array.isArray(producto_id) && producto_id.length > 0) {
    producto_id.forEach((id) => queryParams.append("producto_id", id));
  } else if (producto_id) {
    queryParams.append("producto_id", producto_id);
  }

  if (estado_serial_id)
    queryParams.append("estado_serial_id", estado_serial_id);

  if (serial) queryParams.append("serial", serial);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_URL_SERIAL}/seriales?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
